import { tripOrgInfoFun } from '../../../api/orgTripAPI';

export const FetchOrgAccount = (setAccDetails, setLoading, type) => {
    setLoading(true);
    if (type === 'guide') {
        type = 'gu';
    }
    try {
        tripOrgInfoFun(type).then((item) => {
            if (item.status === 200) {
                setAccDetails(item.data);
            }
            setLoading(false);
        });
    } catch (error) {
        setLoading(false);
    }
};
